import { reactive, ref } from 'vue'
import { useApi } from '@/functions/api'
import { toast } from '@/stores/toast'

export function useCurrencyList () {
  const api = useApi()
  const currencies = ref<Currency[]>([])
  const loading = ref(false)

  const getData = async (params = {}) => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Currency>>('admin/currency', params)
      currencies.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    currencies,
  }
}

export function useCurrencyEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = reactive<CurrencyForm>({
    code: '',
    rate_for_setting_sell_price: 0,
  })

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      toast.dataSaved()
      return await api.PUT<Currency>(`admin/currency/${id}`, {
        rate_for_setting_sell_price: form.rate_for_setting_sell_price,
      })
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
  }
}

export function useCurrencyDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitDelete = async (id: number) => {
    try {
      submitting.value = true
      await api.DELETE(`admin/currency/${id}`)
      toast.dataDeleted()
      return id
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
  }
}
